import styled from 'styled-components';
import { Button } from '../Button';

export const Action = styled(Button)`
  width: 32px;
  height: 32px;  
  padding: 0;
  text-align: center;
  .icon{
    fill: ${(props) => props.color};    
    stroke: ${(props) => props.stroke};
  }
`;
